module.exports = __webpack_public_path__ + "static/GlitchlessSonyax47-cf173d2622bf2cb858950a5197b73a17.png";